module.exports = __webpack_public_path__ + "static/media/kr.6031b375.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/kr.svg
// module id = 167
// module chunks = 0